<script lang="ts">
  import { SquareArrowOutUpRight } from "lucide-svelte"

  interface Props {
    user: UserType | ExternalRecipientType
    onupdate: (selected: boolean) => void
  }

  let { user, onupdate }: Props = $props()
</script>

<button
  data-name="recognition-recipient"
  class="my-2 mx-2 image-button relative"
  onclick={() => onupdate(user._selected)}
  type="button"
  tabindex="0"
>
  {#if user.external}
    <div class="absolute top-2 right-2">
      <SquareArrowOutUpRight
        class="size-5 text-blue-700 bg-blue-100 rounded-lg"
      />
    </div>
  {/if}
  <span
    class="rounded-full min-h-20 min-w-20 w-20 h-20 flex items-center p-2 mx-auto cursor-pointer"
  >
    <img
      class="h-full min-h-20 min-w-20 w-20 rounded-full mx-auto hover:border-blue-400 {user._selected
        ? 'border-4 border-blue-500 bg-blue-200'
        : 'border-2 border-gray-100'}"
      src={user.avatar_thumb_url}
      alt={user.name_with_initial}
    />
  </span>
  <p class="text-center text-xs">
    {user.name_with_initial}
  </p>
</button>
